import {call, put, select, takeEvery} from "redux-saga/effects"

import {
  NotificationsTypes as Types,
  NotificationsCreators as Creators
} from "./redux"
import {AppCreators} from "../App/redux"
import {LangSwitchCreators as LangCreators} from "../../components/LangSwitch/redux"
import {vars} from "../../config"
import api from "../../services/ApiService"
import {checkEnv, i18n, log} from "../../utils"

export default function* router(dispatch, _action) {
  const state = yield select()

  // subscribe to request action
  yield takeEvery(Types.NOTIFICATIONS_REQUEST, fetch, dispatch)

  // subscribe to read all action
  yield takeEvery(Types.NOTIFICATIONS_READ_ALL_REQUEST, readAll, dispatch)

  // trigger initial action
  yield put(Creators.request(vars.notifications.perPage, 0, false))

  // set lang url
  if (state.app.lang === "de") {
    yield put(
      LangCreators.success(state.router.route.replace("/:lang/", "/en/"))
    )
  } else {
    yield put(
      LangCreators.success(state.router.route.replace("/:lang/", "/de/"))
    )
  }

  // tracking
  yield put(
    AppCreators.trackingAdd({
      event: "mtm.virtualPageView",
      section: "notifications",
      document_title: `${i18n.t("Benachrichtigungen")}`
    })
  )
}

export function* fetch(_dispatch, {perPage, offset, append}) {
  const lang = (yield select()).app.lang

  // if notifications are disabled
  if (checkEnv("DISABLE_NOTIFICATIONS")) {
    yield put(Creators.error("Notifications are disabled."))
    return
  }

  try {
    const response = yield call(api.getNotifications, lang, perPage, offset)

    yield put(
      Creators.success(response.notifications, response.unread_count, append)
    )
  } catch (e) {
    yield put(Creators.error(e.message))
  }
}

export function* read(_dispatch, {id}) {
  try {
    const response = yield call(api.readNotification, id)

    yield put(Creators.readNotificationSuccess(response.read_at, response.id))
    yield put(
      AppCreators.readNotificationSuccess(response.read_at, response.id)
    )
  } catch (e) {
    yield log.dev("Notification could not be marked as read")
    yield log.dev(e)
  }
}

export function* readAll(_dispatch, _action) {
  try {
    const response = yield call(api.readAllNotifications)

    yield put(Creators.readNotificationsAllSuccess(response.read_at))
    yield put(AppCreators.readNotificationsAllSuccess(response.read_at))
  } catch (e) {
    yield log.dev("Notifications could not be marked as read")
    yield log.dev(e)
  }
}



// WEBPACK FOOTER //
// ./src/containers/Notifications/sagas.js